import { GenericFieldFactory } from "../../Common/_generics/GenericFieldFactory";

// The one PMS account a screen was sent to look at, when it was sent from
// a concrete integration ("edit the integration", "go to PMS account") and
// not from the catalog. `{ company, uid, name }`, or `null` when the catalog
// is browsed as a whole. The company's panel narrows itself to that account
// while it is in view; the module drops the focus when the panel closes.
export const PMSFocusedTemplateStore = GenericFieldFactory("PMS_FOCUSED_TEMPLATE");
